import CategoriesList from './CategoriesListContainer'
export default CategoriesList
